import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  addLinkButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
  },

  colorCircle: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: '50%',
  },

  colorPreviewSelect: {
    width: '100%',
    height: 24,
  },

  actionButtons: {
    display: 'flex', 
    justifyContent: 'space-between',
  },

  dialog: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: 0,
    zIndex: theme.zIndex.modal,
    width: '36rem',
    borderRadius: theme.shape.borderRadius,
    outline: 'none',
  },

  title: {
    fontWeight: theme.typography.fontWeightBold,
  },

  closeButton: {
    position: 'absolute',
    right: '1rem',
    top: '1rem',
  },

  dialogActionButtons: {
    '& button': {
      color: theme.palette.primary.main,
    }
  },

  remainingLinks: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    fontSize: '1.5rem'
  },
}));